import { render, staticRenderFns } from "./BusinessOwnerDocument.vue?vue&type=template&id=0bb736b5"
import script from "./BusinessOwnerDocument.vue?vue&type=script&lang=ts"
export * from "./BusinessOwnerDocument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports